import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AbstractNgModelComponent } from './abstract-ng-model.component';

@Component({ selector: 'abstract-input-array', template: '' })
export class AbstractInputArrayComponent extends AbstractNgModelComponent<
  any[]
> {
  @Input()
  readonly: boolean = false;

  @Input()
  required: boolean = false;

  @Input()
  placeholder: string = '';

  @Input()
  type: string = 'text';

  @Output()
  onBlur = new EventEmitter<void>();

  @Output()
  onFocus = new EventEmitter<void>();
  // add a function that checks if there are validation errors

  get inputReadonly(): boolean {
    return this.readonly || typeof this.readonly !== 'boolean';
  }

  get inputRequired(): boolean {
    return this.required || typeof this.required !== 'boolean';
  }
}
